// A failed request made with `responseType: 'blob'` returns its JSON error body
// as a Blob, so it has to be read back before `detail` can be pulled out of it.
export default async function readBlobErrorDetail(error) {
  const data = error?.response?.data;
  if (!data) return null;
  if (!(data instanceof Blob)) return data?.detail || null;

  try {
    return JSON.parse(await data.text())?.detail || null;
  } catch {
    return null;
  }
}
